module.exports = __webpack_public_path__ + "static/media/zind.93575813.jpg";